import React, { useEffect, useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

const GoogleCallback = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  useEffect(() => {
    if (searchParams.get('token')) {
      localStorage.setItem('signin-success', 'true')
      localStorage.setItem('token', searchParams.get('token'))
    }
    if (searchParams.get('errorMessage')) {
      localStorage.setItem('errorMessage', searchParams.get('errorMessage'))
    }
    if (searchParams.get('successMessage')) {
      localStorage.setItem(
        'successMessage',
        searchParams.get('successMessage')
      )
    }
    window.close()
  }, [searchParams])
  return <div>GoogleCallback</div>
}

export default GoogleCallback
